import { breakpointsTailwind, useBreakpoints } from '@vueuse/core';

export const useIsDesktop = (limit: keyof typeof breakpointsTailwind = 'lg') => {
	const breakpoints = useBreakpoints(breakpointsTailwind);
	const desktop = breakpoints.greater(limit);
	return desktop;
};
